<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-1-the-enchanted-village">
<h1>Chapter 1<br/> The Enchanted Village</h1>
<p>Tucked away deep in the beautiful countryside was a quiet sleepy village with just a handful of out-of-date shops which really needed pulling down; it was as if time had stood still. Most people did their shopping in the busy nearby town. But visitors couldn’t help but notice that the tiny old village had something special and mystical about it.</p>
<p>The old shops and houses certainly had their mystery stories to tell. Nothing had been built for years; no new shops or buildings, no new anything. Surrounding villages had been slowly modernised over time, with rows of new houses built and even a new school in one village.</p>
<p>The upkeep of the old bandstand and the children’s play park relied very much on local dads having any spare time to carry out repairs.</p>
<p>The shallow river that flowed along the edge of the village was a magnet to the local boys who would spend endless hours fishing. If you didn’t fish there wasn’t much else to do during the holidays.</p>
<p>What was surprising was that nobody moved out of the village. The older generation had been living there since they were born.</p>
<p>You could let your imagination run away with you as you walked through the village and think of ghosts lurking in the shadows of bordered-up derelict houses.</p>
<p>Rumours of magical things happening in the village were folk law. The old people living in the village, and children in particular who seemed to have a sixth sense about it, just knew this was true. Their parents were nonbelievers and thought that these were fairy tale stories made up by the children.</p>
<p>But what was the truth?</p>
<p>Read on and all will be revealed.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?39c1781f